import { render, staticRenderFns } from "./SideMoodHmStats.vue?vue&type=template&id=70a81125&scoped=true"
import script from "./SideMoodHmStats.vue?vue&type=script&lang=js"
export * from "./SideMoodHmStats.vue?vue&type=script&lang=js"
import style0 from "./SideMoodHmStats.vue?vue&type=style&index=0&id=70a81125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a81125",
  null
  
)

export default component.exports